import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { AppVersion } from '@ionic-native/app-version';
import { Zip } from '@ionic-native/zip';
import { EmailComposer } from '@ionic-native/email-composer';
import { Insomnia } from '@ionic-native/insomnia';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient, HttpClientModule } from "@angular/common/http"; 
import { SocialSharing } from '@ionic-native/social-sharing';

import { AuthProvider } from '../providers/auth/auth';
import { FileProvider } from '../providers/file/file';
import { StorageProvider } from '../providers/storage/storage';
import { CategoriesProvider } from '../providers/categories/categories';
import { KeywordProvider } from '../providers/keyword/keyword';
import { IndicationProvider } from '../providers/indication/indication';
import { AssetProvider } from '../providers/asset/asset';
import { SynchroProvider } from '../providers/synchro/synchro';
import { WebserviceProvider } from '../providers/webservice/webservice';
import { HelperProvider } from '../providers/helper/helper';
import { NotificationProvider } from '../providers/notification/notification';
import { LanguageProvider } from '../providers/language/language';
import { AudienceProvider } from '../providers/audience/audience';
import { FilterProvider } from '../providers/filter/filter';
import { OrderProvider } from '../providers/order/order';
import { LocalfileProvider } from '../providers/localfile/localfile';

import { ReactiveFormsModule } from '@angular/forms';

import { ComponentsModule } from '../components/components.module';
import { NotificationComponent } from '../components/notification/notification';

import { FavoritesPageModule } from '../pages/favorites/favorites.module';
import { FilRougePageModule } from '../pages/fil-rouge/fil-rouge.module';
import { RecentsPageModule } from '../pages/recents/recents.module';
import { SearchPageModule } from '../pages/search/search.module';
import { SubcategoriesPageModule } from '../pages/subcategories/subcategories.module';
import { LoginPageModule } from '../pages/login/login.module';
import { BriefcasePageModule } from '../pages/briefcase/briefcase.module';
import { ViewerAssetPageModule } from '../pages/viewer-asset/viewer-asset.module';
import { UserInformationProvider } from '../providers/user-information/user-information';
import { HttpErrorHandlerProvider } from '../providers/http-error-handler/http-error-handler';
import { LocalFilesPageModule } from '../pages/local-files/local-files.module';
import { NotificationsPageModule } from '../pages/notifications/notifications.module';
import { EmailPackagePageModule } from '../pages/email-package/email-package.module';
import { EmailPackageProvider } from '../providers/email-package/email-package';
import { VisitPackageModalPageModule } from '../pages/visit-package-modal/visit-package-modal.module';

export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    IonicModule.forRoot(MyApp, {
      menuType: 'reveal',
      persistent: true,
      swipeEnabled: false,
      mode: 'ios' //force ios mode because of issues with platform detection on iPad with iOS14
    }),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    LoginPageModule,
    BriefcasePageModule,
    SubcategoriesPageModule,
    FilRougePageModule,
    FavoritesPageModule,
    RecentsPageModule,
    SearchPageModule,
    LocalFilesPageModule,
    ComponentsModule,
    ViewerAssetPageModule,
    NotificationsPageModule,
    EmailPackagePageModule,
    VisitPackageModalPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    NotificationComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    File,
    FileOpener,
    AppVersion,
    EmailComposer,
    SocialSharing,
    Zip,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider,
    FileProvider,
    StorageProvider,
    CategoriesProvider,
    KeywordProvider,
    IndicationProvider,
    AssetProvider,
    SynchroProvider,
    WebserviceProvider,
    HelperProvider,
    NotificationProvider,
    LanguageProvider,
    AudienceProvider,
    FilterProvider,
    UserInformationProvider,
    HttpErrorHandlerProvider,
    LocalfileProvider,
    Insomnia,
    OrderProvider,
    EmailPackageProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts